import {
  ContactDictionary,
  ContactDictionaryControllerApi,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useContactDictionaryUpdate = () =>
  useMutationWithLoading(
    async (params: {
      contactDictionary: ContactDictionary;
      xTENANTID?: string;
    }) =>
      new ContactDictionaryControllerApi(
        getConfigObject()
      ).updateContactDictionary(params.contactDictionary, params.xTENANTID)
  );
